/*-----------------------------------------------------------------
- ‌Blog
-----------------------------------------------------------------*/
export default {
    title   : 'وبلاگ',
    category: 'دسته‌بندی‌ها',

    comments: {
        form  : 'دیدگاهتان را بنویسید',
        list  : 'دیدگاه کاربران',
        button: 'نوشتن دیدگاه',
    },

    read_text : 'خواندن این مطلب ۴ دقیقه زمان میبرد.',
    tags      : 'تگ‌ها:',
    separator : '،',
    share     : 'اشتراک‌گذاری',
    short_link: 'لینک کوتاه',
    author_des:
        'دانشجوی ژنتیک دانشگاه اصفهان - عاشق روانشناسی و نویسندگی من خستگی ناپذیرم؛ خستگی ناپذیر از سفر کردن، دیدن چیزهای جدید و نوشتن',

    related: {
        title      : 'مطالب مشابه',
        button_text: 'همه مطالب',
    },

    adv: {
        title      : 'یسناشاپ',
        subtitle   : 'پیشگام در صنعت بوجاری غلات، جبوبات، ادویه‌جات و بسته‌بندی',
        button_text: 'مشاهده محصولات',
    },
    
    copy_value: {
        copied: 'کپی شد!',
        error : 'مشکلی در کپی عبارت به وجود آمده است. لطفا دوباره تلاش کنید.',
    },
};
